'use client';

import { useState } from 'react';

interface IEnglishIqV2TypedAnswerProps {
  disabled: boolean;
  placeholder: string;
  submitLabel: string;
  onSubmit: (text: string) => void;
}

export function EnglishIqV2TypedAnswer({
  disabled,
  onSubmit,
  placeholder,
  submitLabel,
}: IEnglishIqV2TypedAnswerProps): React.JSX.Element {
  const [text, setText] = useState('');
  const normalizedText = text.trim();
  return (
    <form
      className="space-y-4"
      onSubmit={(event) => {
        event.preventDefault();
        if (normalizedText) {
          onSubmit(normalizedText);
        }
      }}
    >
      <label className="sr-only" htmlFor="english-iq-v2-text-answer">
        {placeholder}
      </label>
      <input
        autoComplete="off"
        autoCorrect="off"
        className="min-h-16 w-full rounded-2xl border border-[#f7edda]/20 bg-black/30 px-5 text-lg text-[#fff8e9] caret-[#ff7a1a] outline-none placeholder:text-[#fff8e9]/35 focus:border-[#ff7a1a] focus:ring-4 focus:ring-[#ff7a1a]/15"
        dir="auto"
        disabled={disabled}
        id="english-iq-v2-text-answer"
        onChange={(event) => setText(event.target.value)}
        placeholder={placeholder}
        value={text}
      />
      <button
        className="min-h-12 w-full rounded-full bg-[#ff7a1a] px-6 font-bold text-[#160c06] transition hover:bg-[#ff9448] disabled:cursor-not-allowed disabled:opacity-40 motion-reduce:transition-none sm:w-auto"
        disabled={disabled || !normalizedText}
        type="submit"
      >
        {submitLabel}
      </button>
    </form>
  );
}
